export default __webpack_public_path__ + "static/media/machining.01c91adf.webp";